import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
// @ts-expect-error no types yet
import { bender } from 'legacy-hubspot-bender-context'; // import-eslint-disable-line
import { stringify } from 'hub-http/helpers/params';
import { deployed, isLocal } from './env';
import { getFullUrl } from 'hubspot-url-utils';
const PAGE_PREVIEW_PATH = '_hcms/preview/content';
const TEMPLATE_PREVIEW_PATH = '_hcms/preview/template/multi';
const PRESET_TILE_PREVIEW_PATH = 'content-theme-presets-rendering/v1/tiles/theme-preset-tile';
const getBaseUrl = () => '/theme-editor';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getBranchPreviewBuild = () => {
  if (bender.staticDomain.includes('dynamic.hsappstatic.net')) {
    return bender.staticDomain.split(/b-|\./g)[1];
  }
  return null;
};
const getPreviewPath = (queryParams, previewPageId) => {
  const previewPath = previewPageId ? `${PAGE_PREVIEW_PATH}/${previewPageId}` : TEMPLATE_PREVIEW_PATH;
  return `${previewPath}?${stringify(queryParams)}`;
};

// Portals will use a different URL for the preview iframe
// This domain+path is set on the AppUrlMappings and the domainAndPath
// are set via queryParams for now
export const buildPortalPreviewUrl = (portalInstanceDomain, portalInstancePath, extraParams = {}) => {
  const queryParams = Object.assign({}, extraParams, {
    isPortalPreview: true
  });
  if (isLocal() || !deployed()) {
    queryParams.localAssets = true;
    queryParams.appDomain = document.location.origin;
  }
  if (process.env.LOCAL_PORTAL_PREVIEW_URL) {
    return `${process.env.LOCAL_PORTAL_PREVIEW_URL}?${stringify(queryParams)}`;
  }
  return `https://${portalInstanceDomain}/${portalInstancePath}?${stringify(queryParams)}`;
};
export const isPortalPreviewUrl = url => {
  if (!url) return false;
  return url.includes('isPortalPreview=true');
};
export const buildPreviewUrl = (previewDomain, themePath, previewPageId, previewTemplatePath, extraParams = {}, portalInstanceDomain, portalInstancePath) => {
  const queryParams = Object.assign({
    buffer_theme: true,
    path: previewTemplatePath,
    from_buffer: previewPageId ? false : undefined,
    portalId: PortalIdParser.get(),
    preview_theme: true,
    theme_path: themePath,
    themePreviewerUI: true,
    hsEditorApp: 'theme'
  }, extraParams);
  if (isLocal() || !deployed()) {
    queryParams.localAssets = true;
    queryParams.appDomain = document.location.origin;
  }

  // Pass along branch preview build ID if it exists
  const branchPreviewBuild = getBranchPreviewBuild();
  if (branchPreviewBuild) {
    queryParams.branchPreviewBuild = branchPreviewBuild;
  }

  // Use custom portals URL if portal domain and path are present
  if (portalInstanceDomain && portalInstancePath) {
    return buildPortalPreviewUrl(portalInstanceDomain, portalInstancePath, queryParams);
  }
  const hasPageIdOrTemplatePath = previewPageId || previewTemplatePath;
  if (!themePath || !hasPageIdOrTemplatePath || !previewDomain) {
    return null;
  }
  let previewPath = getPreviewPath(queryParams, previewPageId);
  if (enviro.getShort('preview') === 'local') {
    previewPath = `cos-rendering/v1/public/${previewPath}`;
  }
  return `//${previewDomain}/${previewPath}`;
};
export const getRevisionPreviewQueryParams = (revision, isBuffer) => {
  const isCurrentRevision = revision.id === -1;
  const {
    active_theme_preset_row_id,
    activeThemePresetRowId
  } = revision.object || {};
  const activeThemePresetId = active_theme_preset_row_id || activeThemePresetRowId || 0;
  return {
    theme_settings_version: isCurrentRevision || isBuffer ? null : revision.id,
    theme_preset_id: activeThemePresetId
  };
};
export const buildPresetTilePreviewUrl = (themePath, presetId, ignoreUserThemeOverrides = true, extraParams = {}) => {
  if (!themePath) {
    return null;
  }
  const queryParams = Object.assign({
    buffer_theme: true,
    portalId: PortalIdParser.get(),
    preview_theme: true,
    theme_path: themePath,
    themePreviewerUI: true,
    hsEditorApp: 'theme',
    theme_preset_id: presetId,
    ignore_user_overrides: ignoreUserThemeOverrides
  }, extraParams);
  if (isLocal() || !deployed()) {
    queryParams.localAssets = true;
    queryParams.appDomain = document.location.origin;
  }
  return `${getFullUrl('app')}/api/${PRESET_TILE_PREVIEW_PATH}?${stringify(queryParams)}`;
};
export const updateAssetUrlTimestamp = url => {
  const timestampRegex = /([?&]t=)[^&]+/;
  if (!url.match(timestampRegex)) {
    return `${url}&t=${Date.now()}`;
  }
  return url.replace(timestampRegex, `$1${Date.now()}`);
};
export const getThemeSettingsUrl = () => {
  return `/settings/${PortalIdParser.get()}/website/themes`;
};